import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Field, Form, Formik } from 'formik';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import * as Yup from 'yup';
import Error from '../../../components/share/Error';
import DownloadReportBtn from './DownloadReportBtn';
import { search } from '../../../actions/report';
import useLeadStatus from '../../../commons/useLeadStatus';
import * as _ from 'lodash';
import { FiArrowDown, FiArrowUp } from 'react-icons/fi';
import moment from 'moment';
import CryptoJS from "crypto-js";

export const ReportData = ({ onMount, values }) => {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [itemPerPage, setItemPerPage] = useState(20);
  const [page, setPage] = useState(values || []);
  const [pageCount, setPageCount] = useState(1);
  const [pageIndex, setPageIndex] = useState(1);
  const [sort, setSort] = useState();
  const [filter, setFilter] = useState({ lead_status: '', customer_name: '' });

  const bankStaffs = useSelector((state) => state?.lookup?.bankStaff || []);
  const isTO = useSelector((state) => state?.auth?.isTO);
  const dispatch = useDispatch();
  const { options, getLabel } = useLeadStatus();

  const decryptAES  = (cipherText) => {
    if(cipherText === null) return '';
    cipherText = cipherText.replace('[encrypt]','');
    const decrypted = CryptoJS.AES.decrypt(cipherText, CryptoJS.enc.Utf8.parse('A9F66A37C4C10BBD83F7BA270962731E'), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    return CryptoJS.enc.Utf8.stringify(decrypted);
  }

  const length = (values || []).length;

  const renderBack = () => {
    return pageIndex <= 1 ? null : (
      <a
        className='text-primary'
        onClick={() => {
          const prevPage = pageIndex - 1;
          if (prevPage > 0) {
            const pages = rows?.slice(prevPage * itemPerPage, pageIndex * itemPerPage);
            setPage(pages);
            setPageIndex(prevPage);
          }
        }}
      >
        {'<< '}Trước
      </a>
    );
  };

  const renderNext = () => {
    return pageIndex >= pageCount ? null : (
      <a
        className='text-primary'
        onClick={() => {
          const nextPage = pageIndex + 1;
          if (nextPage <= pageCount) {
            const row = rows?.slice(pageIndex * itemPerPage, nextPage * itemPerPage);
            setPage(row);
            setPageIndex(nextPage);
          }
        }}
      >
        Sau {' >>'}
      </a>
    );
  };

  const renderPageIndex = () => {
    if (pageCount <= 1) return null;
    return (
      <span>
        Trang {pageIndex} / {pageCount}
      </span>
    );
  };

  const renderItemPerPage = () => {
    return (
      <div className='input-group'>
        <label className='input-group-text bg-white border-0 font-weight-bold'>Số hàng mỗi trang</label>
        <select value={itemPerPage} onChange={(e) => setItemPerPage(e.target.value)} className='form-control'>
          <option>5</option>
          <option>10</option>
          <option>20</option>
          <option>50</option>
          <option>100</option>
        </select>
      </div>
    );
  };

  const renderPaging = () => {
    return (
      <div className='d-flex justify-content-between align-items-center'>
        <div>{renderBack()}</div>
        <div>{renderItemPerPage()}</div>
        <div>{renderPageIndex()}</div>
        <div>{renderNext()}</div>
      </div>
    );
  };

  useEffect(() => setRows(values), [values]);

  useEffect(() => {
    let rows = values;
    _.keys(filter).forEach((key) => {
      let value = filter[key];
      if (value) {
        if (key === 'customer_name') {
          rows = _.filter(rows, (r) => _.toUpper(decryptAES(r.customer_name)) === _.toUpper(value));
        } else {
          rows = _.filter(rows, [key, value]);
        }
      }
    });
    setSort({ ref_no: '' });
    setRows(rows);
  }, [filter]);

  useEffect(() => {
    onMount();
  }, [onMount]);

  useEffect(() => {
    let page = (rows || []).slice(0, itemPerPage);
    setPage(page);
    setPageIndex(1);
    setPageCount(Math.floor((rows || []).length / itemPerPage + 1));
  }, [rows, itemPerPage]);

  useEffect(() => {
    const key = _.keys(sort)[0];
    const value = sort?.[key];
    if (value) {
      let newRows;
      if (['dob', 'created_date', 'last_modified_date'].includes(key)) {
        newRows = rows?.sort((first, second) => {
          if (!first || !first[key] || !second || !second[key]) return 1;
          let d1 = moment(first?.[key], 'DD/MM/YYYY');
          let d2 = moment(second?.[key], 'DD/MM/YYYY');
          return !d1.isValid() ? 1 : !d2.isValid() ? 1 : d1.format('YYYYMMDD') - d2.format('YYYYMMDD');
        });
      } else {
        newRows = _.sortBy(rows, [key]);
      }

      if (value === 'desc') newRows = _.reverse(newRows);
      setRows(newRows);
    }
  }, [sort]);

  const onSubmit = async (values, helper) => {
    helper.setSubmitting(true);
    try {
      await axios.post(`/api/leads?reassign`, values);
      helper.setSubmitting(false);
      dispatch(search());
      setOpen(false);
    } catch (error) {
      helper.setSubmitting(false);
      alert('Không thể thực hiện yêu cầu');
    }
  };

  const toggleSort = (name) => {
    let value = sort?.[name] || '';
    if (value === 'asc') value = 'desc';
    else if (value === 'desc') value = 'asc';
    else value = 'asc';
    setSort({ [name]: value });
  };

  const initialValues = {
    bankStaffCode: '',
    seqList: [],
  };

  const validationSchema = Yup.object().shape({
    bankStaffCode: Yup.string().required('Chọn từ danh sách'),
    seqList: Yup.array().min(1, 'Chọn ít nhất 1 lead từ danh sách'),
  });

  const renderArrow = (name) => {
    return <> {sort?.[name] === 'asc' ? <FiArrowUp /> : sort?.[name] === 'desc' ? <FiArrowDown /> : null}</>;
  };

  const renderTable = () => (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      enableReinitialize={true}
    >
      {(props) => (
        <Form>
          <div>
            <span>
              Tìm thấy <b>{length}</b> kết quả
            </span>
            {length === 0 ? null : (
              <div className='d-inline-block float-right mb-1'>
                <DownloadReportBtn />{' '}
                {isTO ? (
                  <Button color='primary' onClick={() => setOpen(true)} disabled={props.isSubmitting}>
                    Chuyển
                  </Button>
                ) : null}
              </div>
            )}
          </div>
          {isTO ? (
            <Modal isOpen={open} size='lg'>
              <ModalHeader toggle={() => setOpen(!open)} className='border-bottom-0'>
                {' '}
              </ModalHeader>
              <ModalBody className='border-bottom-0'>
                <fieldset>
                  <legend>
                    Chuyển <span className='text-primary'>{(props.values.seqList || []).length} lead</span> cho nhân
                    viên ngân hàng:
                  </legend>
                  <Field name='bankStaffCode' as='select' className='form-control'>
                    <>
                      <option value=''>Chọn...</option>
                      {bankStaffs.map((s, i) => (
                        <option key={`${s.value}_${i}`} value={s.value}>
                          {s.label}
                        </option>
                      ))}
                    </>
                  </Field>
                  <Error name='seqList' />
                  <Error name='bankStaffCode' />
                </fieldset>
              </ModalBody>
              <ModalFooter className='border-top-0'>
                <Button color='primary' onClick={props.submitForm} disabled={!(props.dirty && props.isValid)}>
                  Hoàn tất
                </Button>{' '}
                <Button
                  outline
                  color='primary'
                  onClick={() => {
                    props.resetForm();
                    setOpen(!open);
                  }}
                >
                  Hủy
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}

          <table className='table'>
            <thead>
              <tr className='bg-secondary text-white'>
                {isTO ? <th /> : null}
                <th className='align-top' onClick={() => toggleSort('ref_no')}>
                  <span>Mã tham chiếu</span>
                  {renderArrow('ref_no')}
                </th>
                <th className='align-top' onClick={() => toggleSort('bank_staff_code')}>
                  <span>Người giới thiệu</span>
                  {renderArrow('bank_staff_code')}
                </th>
                <th className='align-top' onClick={() => toggleSort('created_date')}>
                  <span>Ngày giới thiệu</span>
                  {renderArrow('created_date')}
                </th>
                <th className='align-top' onClick={() => toggleSort('last_modified_date')}>
                  <span>Thời gian cập nhật gần nhất</span>
                  {renderArrow('last_modified_date')}
                </th>
                <th className='align-top' onClick={() => toggleSort('customer_name')}>
                  <span>Tên KH</span>
                  {renderArrow('customer_name')}
                </th>
                <th className='align-top' onClick={() => toggleSort('dob')}>
                  <span>Ngày sinh</span>
                  {renderArrow('dob')}
                </th>
                <th className='align-top' onClick={() => toggleSort('mobile_number')}>
                  <span>Số điện thoại</span>
                  {renderArrow('mobile_number')}
                </th>
                <th className='align-top' onClick={() => toggleSort('email')}>
                  <span>Email</span>
                  {renderArrow('email')}
                </th>
                <th className='align-top'>
                  <span>Tình trạng</span>
                </th>
              </tr>
              <tr>
                {isTO ? <th /> : null}
                <td />
                <td />
                <td />
                <td />
                <td>
                  <Input
                    value={filter.customer_name || ''}
                    onChange={(e) => setFilter({ ...filter, customer_name: e.target.value })}
                    placeholder='Họ và tên...'
                  />
                </td>
                <td />
                <td />
                <td />
                <td>
                  <Input type='select' onChange={(e) => setFilter({ ...filter, lead_status: e.target.value })}>
                    <>
                      <option value=''>Tất cả</option>
                      {options?.map((o) => (
                        <option key={o.value} value={o.value}>
                          {o.label}
                        </option>
                      ))}
                    </>
                  </Input>
                </td>
              </tr>
            </thead>
            <tbody>
              {page?.map((lead, i) => (
                <tr key={`${lead?.seq || ''}_${i}`}>
                  {isTO ? (
                    <td
                      onClick={() => {
                        let seqList = props?.values?.seqList || [];
                        if (seqList.includes(lead?.seq)) {
                          let nextValue = seqList.filter((value) => value !== lead?.seq);
                          props.setFieldValue('seqList', nextValue);
                        } else {
                          let nextValue = seqList.concat(lead?.seq);
                          props.setFieldValue('seqList', nextValue);
                        }
                      }}
                    >
                      <input
                        name='seq'
                        type='checkbox'
                        value={lead?.seq}
                        onChange={() => undefined}
                        checked={(props?.values?.seqList || []).includes(lead?.seq)}
                        className='custom-checkbox'
                      />
                    </td>
                  ) : null}
                  <td>{lead?.ref_no}</td>
                  <td>{lead?.bank_staff_name}</td>
                  <td>{lead?.created_date}</td>
                  <td>{lead?.last_modified_date}</td>
                  <td>
                    <Link to={`/leads/${lead.seq}`}>{decryptAES(lead?.customer_name)}</Link>
                  </td>
                  <td>{decryptAES(lead?.dob)}</td>
                  <td>{decryptAES(lead?.mobile_number)}</td>
                  <td>{decryptAES(lead?.email)}</td>
                  <td>{getLabel(lead?.lead_status)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={9}>{renderPaging()}</td>
              </tr>
            </tfoot>
          </table>
        </Form>
      )}
    </Formik>
  );
  return <div className='report__data'>{length > 0 ? renderTable() : null}</div>;
};

const mapStateToProps = (state) => {
  let title = (state?.lookup?.title || []).reduce(
    (result, current) => Object.assign({}, result, { [current.value]: current.label }),
    {}
  );
  let status = (state?.lookup?.status || []).reduce(
    (result, current) => Object.assign({}, result, { [current.value]: current.label }),
    {}
  );
  let maritalStatus = (state?.lookup?.maritalStatus || []).reduce(
    (result, current) => Object.assign({}, result, { [current.value]: current.label }),
    {}
  );

  return {
    values: state?.report?.data || [],
    title,
    status,
    maritalStatus,
    loading: state?.report?.loading,
  };
};

const mapDispatchToProps = { onMount: search };

export default connect(mapStateToProps, mapDispatchToProps)(ReportData);
